import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todos os plantios cadastradas no banco de dados
 */
const getAllPlantios = async () => {
	return registryApi.get('v2/Plantio')
}

/**
 * Retorna todos os plantios cadastradas no banco de dados com paginação
 * @param {number} PagNumber - Número da página
 * @param {number} PagSize - Tamanho da página
 * @param {string} FilteringWord - Palavra chave busca  */

const getAllPlantiosPagination = async (PagNumber, PagSize, FilteringWord) => {
	return registryApi.post('v2/Plantio/GetToCrudTable', { PagNumber, PagSize, FilteringWord })
}

/**
 * Retorna todos os plantios estruturadas para o componente de DropdownFk
 */
const getDropdownPlantios = async () => {
	const { data: result } = await registryApi.get('v2/Plantio/lista-dropdown')
	return result.map((plantio) => {
		return {
			id: plantio.id,
			[i18n.t('code')]: plantio.ptio_cd_codigo,
			[i18n.t('section')]: plantio.tlho_cd_codigo,
			[i18n.t('farm')]: plantio.fzda_nm_nome,
			[i18n.t('forestStratification')]: plantio.esfl_ds_descricao,
		}
	})
}

/**
 * Cadastrar nova plantios no banco de dados
 * @param {Object} body plantio que será cadastrada
 */
const createPlantio = async (body) => {
	return registryApi.post('v2/Plantio', body)
}

/**
 * Atualiza plantio no banco de dados
 * @param {Object} body plantio que será atualizada
 */
const updatePlantio = async (body) => {
	return registryApi.put('v2/Plantio', body)
}

/**
 * Lista dos ids de plantio que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de plantio
 */
const deletePlantioByIdList = async (data) => {
	return registryApi.delete('v2/Plantio/exclui-todos-por-lista-ids', { data })
}

export const getPlantiosByEstratoFlorestalId = (estratoFlorestalId) => {
	return registryApi.get(
		`v1/PlanejamentoEstratoFlorestal/GetPlantiosByEstratoFlorestalId?estratoFlorestalId=${estratoFlorestalId}`,
	)
}

export const getPlantiosPorFazenda = (fazendaId) => {
	return registryApi.get(`v2/Plantio/busca-plantios-por-fazenda?fazendaId=${fazendaId}`)
}

export const validarSeTodosOsPlantiosExistemParaPlanoDeColheita = (body) => {
	return registryApi.post(
		`v2/plantio/validar-se-todos-os-plantios-existem-para-plano-de-colheita`,
		body,
	)
}

export {
	getAllPlantios,
	getDropdownPlantios,
	createPlantio,
	updatePlantio,
	deletePlantioByIdList,
	getAllPlantiosPagination,
}
